import { gql } from 'apollo-boost';

export default gql`
  mutation InsertTheme($objects: [theme_insert_input!]!) {
    insert_theme(objects: $objects) {
      affected_rows
    }
  }
`;
